import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const enumGenericTranslateDialogStyle: StyleRulesCallback = () => {
  return {
    paperWidthMd: {
      width: '500px',
    },
  };
};

export default enumGenericTranslateDialogStyle;
